import React from 'react'

import CorporateAgreementsContainer from 'containers/corporate-agreements/login-container'

import withErrorHandler from 'hoc/withErrorHandler'

const CorporateAgreementsPage = () => <CorporateAgreementsContainer />

export default withErrorHandler(CorporateAgreementsPage)
